var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCart = function SvgIconCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,0A1,1,0,0,0,1,2H3.18l1.839,9.2A1,1,0,0,0,6,12H17.656l-.9,3H6a1,1,0,0,0,0,2H17.5a1,1,0,0,0,.958-.713l1.5-5,0-.017,2-7A1,1,0,0,0,21,3H5.42L4.981.8A1,1,0,0,0,4,0ZM6.82,10l-1-5H19.674l-1.429,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11,21a3,3,0,1,1-3-3A3,3,0,0,1,11,21ZM9,21a1,1,0,1,1-1-1A1,1,0,0,1,9,21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,24a3,3,0,1,0-3-3A3,3,0,0,0,17,24Zm0-2a1,1,0,1,0-1-1A1,1,0,0,0,17,22Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cart.b8586764.svg";
export { ForwardRef as ReactComponent };